import { render, staticRenderFns } from "./SwitchIcon.vue?vue&type=template&id=53cfed00"
import script from "./SwitchIcon.vue?vue&type=script&lang=js"
export * from "./SwitchIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports